var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReply = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 16.875C13.5 17.8453 14.6391 18.3494 15.3603 17.7264L23.6105 10.6014C24.1295 10.1532 24.1302 9.34739 23.6105 8.89856L15.3603 1.77426C14.6382 1.15059 13.5 1.65689 13.5 2.6257V6.37818C5.97052 6.46439 0 7.97343 0 15.109C0 17.9891 1.85536 20.8423 3.90624 22.334C4.54622 22.7995 5.45831 22.2152 5.22234 21.4606C3.2493 15.1507 5.80801 13.1431 12 12.8039C12.4784 12.7777 12.9786 12.7615 13.5 12.754V16.875ZM15 6.37818C15 7.19991 14.3389 7.86868 13.5172 7.87809C9.78311 7.92084 6.72046 8.32546 4.62465 9.42768C3.61036 9.96111 2.85461 10.6422 2.34191 11.5098C1.82718 12.3808 1.5 13.5372 1.5 15.109C1.5 16.6758 2.21376 18.3087 3.2245 19.5935C2.80857 17.0887 3.19752 14.9903 4.82178 13.4942C5.80023 12.5929 7.08782 12.0612 8.51004 11.7396C9.9379 11.4167 11.6138 11.281 13.4784 11.2541C13.8799 11.2484 14.267 11.4038 14.553 11.6857C14.839 11.9676 15 12.3524 15 12.754V16.0557L22.3015 9.75001L15 3.44497V6.37818ZM14.38 2.90955C14.3801 2.9097 14.3798 2.90941 14.38 2.90955ZM14.3799 16.5912C14.3797 16.5914 14.3801 16.591 14.3799 16.5912Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReply);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reply.a7ab1bd934b4abf54a19c146c70352c9.svg";